/* eslint-disable import/newline-after-import */
/* Combine all available reducers to a single root reducer.
 *
 * CAUTION: When using the generators, this file is modified in some places.
 *          This is done via AST traversal - Some of your formatting may be lost
 *          in the process - no functionality should be broken though.
 *          This modifications only run once when the generator is invoked - if
 *          you edit them, they are not updated again.
 */
/* Populated by react-webpack-redux:reducer */
import { combineReducers } from 'redux';

function tournaments(state = [], action) {
  switch (action.type) {
    case 'RECEIVE_TOURNAMENTS':
      return action.tournaments;
    case 'RECEIVE_TOURNAMENT':
      return [...state.filter((player) => { return player.id !== action.tournament.id; }), action.tournament];
    default:
      return state;
  }
}

function user(state = null, action) {
  switch (action.type) {
    case 'RECEIVE_USER_PROFILE':
      return action.user;
    case 'LOGGED_OUT':
      return null;
    default:
      return state;
  }
}

const reducers = {
  tournaments: tournaments,
  user: user
};

const combined = combineReducers(reducers);
module.exports = combined;



// WEBPACK FOOTER //
// ./reducers/index.js